import React, {useEffect, useState} from "react";
import classNames from "classnames";

import ElementModal from "./ElementModal";
import Row from "../Layout/Row";
import Column from "../Layout/Column";
import Checkbox from "../Checkbox";

import style from './_modal.module.scss';
import Roles from "../../constants/Roles";


export default function UserModal({open, onClose, onSubmit, defaultValue, loggedUser}) {

	let [user, setUser] = useState(defaultValue || {});
	let [errors, setErrors] = useState(null);
	let [modifyPwd, setModifyPwd] = useState(false);
	let [showPwd, setShowPwd] = useState(false)
	let [projectSearch, setProjectSearch] = useState("")
	let className = classNames([style.modal, style.newUserModal]);
	let isSuperuser = defaultValue && Roles.isSuperUser(defaultValue);

	useEffect(() => {
		let newUser = defaultValue ? Object.assign({}, defaultValue) : {};
		if (newUser.role) newUser.role = newUser.role.name;
		if (newUser.projects) newUser.projects = newUser.projects.map(p => p.id);
		setUser(newUser);
	}, [defaultValue]);

	function onChange(name, value) {
		let newUser = Object.assign({}, user, {[name]: value});
		setUser(newUser);
		setErrors(null);
	}

	function submit() {
		if (!user.firstName) {
			setErrors("Specifica il nome dell'utente");
			return;
		}
		if (!user.lastName) {
			setErrors("Specifica il cognome dell'utente");
			return;
		}
		if (!user.email) {
			setErrors("Specifica l'indirizzo email dell'utente");
			return;
		}
		let userToSend = {
			id: user.id,
			firstName: user.firstName,
			lastName: user.lastName,
			phoneNumber: user.phoneNumber,
			email: user.email,
			projectIds: user.projects,
			roleId: Roles.types.find(r => r.code === (user.role || Roles.names.USER)).id
		};
		if (modifyPwd) {
			if (!user.password || user.password === '' || !user.checkpassword || user.checkpassword === '') {
				setErrors("Inserisci e conferma la password");
				return;
			}
			if (user.password !== user.checkpassword) {
				setErrors("Le Password non corrispondono");
				return;
			}
			userToSend.password=user.password
		}
		// console.log(userToSend)
		onSubmit(userToSend);
	}

	let projectsList = Roles.isSuperUser(loggedUser) && loggedUser.projects;

	return (
		<ElementModal isOpen={open} onClose={onClose} className={className} error={errors} submit={submit}>
			<Row className={style.fields}>
				<Column>
					<input
						type={"text"}
						placeholder={"Nome"}
						onChange={(e) => onChange("firstName", e.target.value)}
						value={user.firstName}
					/>
				</Column>
				<Column>
					<input type={"text"} placeholder={"Cognome"} onChange={(e) => onChange("lastName", e.target.value)}
					       value={user.lastName}/>
				</Column>
			</Row>
			<Row className={style.fields}>
				<Column>
					<input type={"text"} placeholder={"Email"} disabled={!!defaultValue} onChange={(e) => onChange("email", e.target.value)}
					       value={user.email}/>
				</Column>
				<Column>
					<input type={"text"} placeholder={"Cellulare"}
					       onChange={(e) => onChange("phoneNumber", e.target.value)}
					       value={user.phoneNumber}/>
				</Column>
			</Row>
			{!isSuperuser && <Row>
				<Checkbox
					checked={modifyPwd}
					onCheck={() => setModifyPwd(!modifyPwd)}
					name="checkedB"
					color="primary"
				/>
				Modifica la password
			</Row>}
			{
				modifyPwd && !isSuperuser && <>
					<Row className={style.fields}>
						<Column>
							<input type={showPwd ? "text" : "password"} placeholder={"Password"}
								onChange={(e) => onChange("password", e.target.value)}
								value={user.password}
							/>
						</Column>
						<Column>
							<input type={showPwd ? "text" : "password"} placeholder={"Ripeti Password"}
								onChange={(e) => onChange("checkpassword", e.target.value)}
								value={user.checkpassword}
							/>
						</Column>
					</Row>
					<Row>
						<Checkbox
							checked={showPwd}
							onCheck={() => setShowPwd(a => !a)}
							name="showPwdCheck"
							color="primary"
						/>
						Mostra la password
					</Row>
				</>
			}
			{!isSuperuser && projectsList &&
				<Column className={classNames(style.section, style.projectList)} >
					<Row>
						<div className={style.title}>PROGETTI ASSEGNATI</div>
						<input className={style.searchbar}
							type={"text"}
							placeholder={"Cerca"}
							value={projectSearch}
							onChange={e => {setProjectSearch(e.target.value);}}
						/>
					</Row>
					{
						projectsList
							.filter(p => p.name.toLowerCase().includes(projectSearch.toLowerCase()))
							// ordino i progetti elencando per prima i progetti assegnati, poi ordino per nome
							.sort((a, b) => {
								let assignedA = user.projects && !!user.projects.find(p => p === a.id)
								let assignedB = user.projects && !!user.projects.find(p => p === b.id)
								if (assignedA === true && assignedB === false)
									return -1
								else if (assignedA === false && assignedB === true)
									return 1
								else
									return a.name.localeCompare(b.name)
							})
							.map(({id, name}) => (
								<Row key={id}>
									<Column>
										<Checkbox
											checked={user.projects && !!user.projects.find(p => p === id)}
											onCheck={() => {
												let projects = user.projects;
												if (!projects)
													onChange("projects", [id]);
												else if (projects.find(p => p === id))
													onChange("projects", projects.filter(p => p !== id));
												else {
													projects.push(id);
													onChange("projects", projects);
												}
											}}
										/>
									</Column>
									<Column>
										{name}
									</Column>
								</Row>
							)
						)
					}
				</Column>
			}
			{!isSuperuser && Roles.isSuperUser(loggedUser) &&
				<Column className={style.section}>
					<div className={style.title}>RUOLO</div>
					<Row>
						<Checkbox
							checked={user.role === Roles.names.ADMIN}
							onCheck={() => onChange("role", Roles.names.ADMIN)}
						/>
						{Roles.types.find(r => r.code === Roles.names.ADMIN).name}
					</Row>
					<Row>
						<Checkbox
							checked={user.role === Roles.names.USER}
							onCheck={() => onChange("role", Roles.names.USER)}
						/>
						{Roles.types.find(r => r.code === Roles.names.USER).name}
					</Row>
				</Column>
			}
		</ElementModal>
	);
}
